







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import RujukanEdukasiInputModal from "@/components/modal/RujukanEdukasiInputModal.vue";
import { storeSuratRujukanEdukasi } from "@/store/modules/SuratRujukanEdukasiStore";
import SuratRujukanEdukasiSvc from "@/services/SuratRujukanEdukasi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    RujukanEdukasiInputModal
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardRujukanEdukasi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalSurat = false;
  modalTtd = false;
  signRole = "";
  deleting = false;
  editDataSurat: any = null;

  mounted() {
    storeSuratRujukanEdukasi.getByRegister(this.register);
  }

  formatDate(date) {
    return getHumanDateTime(date);
  }

  get stateuser() {
    return userModule.user;
  }

  get stateSurat() {
    return storeSuratRujukanEdukasi.surat;
  }

  get canMakeSurat() {
    if (this.readOnly) return false;
    return ["dokter", "perawat", "bidan"].includes(
      this.stateuser.profesi?.toLowerCase()
    );
  }

  get canEdit() {
    return this.stateSurat && this.canMakeSurat;
  }

  get canSignDpjp() {
    return (
      this.canEdit &&
      this.stateuser.id == this.stateSurat?.dpjp?.id &&
      !this.stateSurat?.signed_dpjp
    );
  }

  get canSignMpp() {
    return (
      this.canEdit &&
      this.stateSurat?.mpp &&
      this.stateuser.id == this.stateSurat?.mpp?.id &&
      !this.stateSurat?.signed_mpp
    );
  }

  openSuratModal() {
    this.editDataSurat = null;
    this.modalSurat = true;
  }

  editSurat() {
    this.editDataSurat = this.stateSurat;
    this.modalSurat = true;
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFn =
      this.signRole === "dpjp"
        ? SuratRujukanEdukasiSvc.signDpjp
        : SuratRujukanEdukasiSvc.signMpp;

    const resp = await signFn(this.stateSurat.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(
        `Berhasil Tanda Tangan ${this.signRole.toUpperCase()}`
      );
      appModule.addMsgTtd("");
      storeSuratRujukanEdukasi.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakSurat() {
    SuratRujukanEdukasiSvc.print(this.stateSurat.id);
  }

  async remove() {
    const q = confirm(
      "Anda yakin akan menghapus Surat Rujukan Edukasi ini?"
    );

    if (q && !this.deleting) {
      this.deleting = true;

      try {
        const resp = await SuratRujukanEdukasiSvc.destroy(this.stateSurat.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storeSuratRujukanEdukasi.getByRegister(this.register);
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
